export * from "@/ui/components/primitives/Separator/Separator";
export * from "@/ui/components/primitives/Separator/Separator.config";
